import React from 'react';
import {Link} from 'react-router'

export default class home extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: "70%"}});
        $('.animate').each(function (i, ele) {
            new ScrollMagic.Scene({triggerElement: ele, offset: -200})
            //.addIndicators()
                .setTween($(ele).find('.animate-this'), 1,
                    {
                        x: 0,
                        y: 0,
                        opacity: 1
                    }).addTo(controller);
        })
        var options = {
            id: 210467745,
            width: 640,
            loop: true
        };

        var player = new Vimeo.Player('videoabout', options);
        player.setVolume(0);
        player.play()
    }

    render() {
        return <section>
            <div className="video-wrapper relative">
                <div id="videoabout"></div>
                <div style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: "100px",
                    color: "white",
                    zIndex: 99
                }}>
                    <div className="" style={{width: "30vw", float: "right", paddingTop: "14vw", paddingRight: "5vw"}}>
                        <h1>JOEL<br/>KERNA<br/>SENKO</h1>
                        <p style={{width: "70%"}}>
                            Joel Kernasenko - ein Leben für das perfekte Foto.
                            Seit 2010 selbständiger Fotograf aus Graz, der gerne neue Zugänge und Perspektiven
                            in seine
                            Arbeit einfließen lässt, die Herausforderung sucht und am liebsten Benzin
                            frühstückt.
                        </p>
                    </div>
                </div>
            </div>
            <div className="container" style={{paddingTop: "5vw", paddingBottom: "10vw"}}>
                <div className="row row-align-middle">
                    <div className="gr-8 text-right">
                        <div className="padding-right-50">
                            <h2>Gerfried Guggi<br/>CINEMATOGRAPHER</h2>
                            <div className="width-percent-70 pull-right">
                                <p>
                                    I’m a filmmaker working as a Director of Photography for documentary, advertising,
                                    corporate and narrative film and video productions. Also specialised in assisting
                                    with previsualization and colorgrading.
                                </p>
                                <p>
                                    <b>CONTACT</b><br/><a href="http://www.gerfriedguggi.com/" target="_blank">www.gerfriedguggi.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="gr-4">
                        <img src="public/images/about/guggi.jpg" alt="" className="image-resp"/>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image fixed content-center"
                 style={{backgroundImage: "url(public/images/about/contact.jpg)"}}>
                <div className="inner text-right">
                    <h1>STUDIO</h1>
                    <p className="about pull-right" style={{background: "white", color: "black", width: "300px"}}>
                        Joel Kernasenko <br/>
                        Moosbrunnweg 8 <br/>
                        8042 Graz – Austria <br/>
                        <a href="tel:+43 / 699 171 252 43">+43 / 699 171 252 43</a> <br/>
                        <a href="mailto:info@joelkernasenko.com">info@joelkernasenko.com</a> <br/>
                        <a href="http://www.joelkernasenko.com" target="_blank">www.joelkernasenko.com</a> <br/>
                        UID: ATU 67632724 <br/><br/>
                        <a href="#/impressum" style={{textDecoration: "underline"}}>Impressum</a> <br/>
                        <a href="/agb/" style={{textDecoration: "underline"}}>AGB</a>
                    </p>
                    <div className="clearfix"></div>
                </div>
            </div>

        </section>
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/about.jsx